import React from 'react';
import styled from 'styled-components';
import {images} from '../../utils/imageExporter'

const MetaContent = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin: 16px;
    margin-top: auto;

    a {
        color: #555;
        font-weight: 500;
        font-size: 12px;
        margin-right: 12px;
        background: #fff;
        padding: 4px 12px;

        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-weight: lighter;
        border-radius: 50px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        transition: all .3s ease;

        &:last-child {
            margin: 0;
        }

        &:hover {
          background: #000;
          color: #fff;
          transition: all .3s ease;
        }

        @media screen and (min-width: 800px) {
            font-size: 12px;
        }

        .metalogo {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
    }
`;

export const MetaData = ({ meta }) => (
    <MetaContent>
      <a href={`mailto:?subject=Take a look at this&body=Hi,%0D%0A%0D%0A I found something interesting on https://news.daresaycloud.co News.%0D%0A%0D%0A Check out this link:%0D%0A ${meta}`}>
        <img width="10" height="10" className="metalogo" src={images.sendIcon} />
        Send
      </a>
    </MetaContent>
  );



// WEBPACK FOOTER //
// ./src/components/Card/MetaData.js